module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      George Gmelch\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("George Gmelch is Professor of Anthropology at the University of San Francisco and Union College. He has studied Irish Travellers, return migrants, commercial fishermen, Alaska natives, Caribbean villagers and tourism workers, and American professional baseball players. He is the author of eleven books, including (with Sharon Bohn Gmelch) Tasting the Good Life: Wine Tourism in the Napa Valley (Indiana University Press, 2011). He has written two other books on Barbados: Double Passage, which is about return migration, and The Parish behind God's Back: The Changing Culture of Rural Barbados. He has also written widely for general audiences, including the New York Times, the Washington Post, Psychology Today, and Natural History.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/vW08W0/tc-custom/9780253001290.jpg?1731798435641",
      "alt": "This image is the cover for the book Behind the Smile"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Behind the Smile\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Behind the Smile is an inside look at the world of Caribbean tourism as seen through the lives of the men and women in the tourist industry in Barbados. The workers represent every level of tourism, from maid to hotel manager, beach gigolo to taxi driver, red cap to diving instructor. These highly personal accounts offer insight into complex questions surrounding tourism: how race shapes interactions between tourists and workers, how tourists may become agents of cultural change, the meaning of sexual encounters between locals and tourists, and the real economic and ecological costs of development through tourism. This updated edition updates the text and includes several new narratives and a new chapter about American students' experiences during summer field school and home stays in Barbados. ")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Indiana University Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0